(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name PresupuestoController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('PresupuestoController', PresupuestoController);

    PresupuestoController.$inject = ["PresupuestoService","$timeout","$location",'$window'];

    function PresupuestoController(PresupuestoService,$timeout,$location,$window)
    {
        var vm = this;
        vm.presupuesto = {};
        vm.filtros = {};
        vm.itsfree = false;

        vm.presupuesto.divisoria_lateral = 0;
        vm.presupuesto.divisoria_central = 0;
        vm.presupuesto.divisoria_2_vidrios = 0;
        vm.presupuesto.divisoria_2_paneles = 0;
        vm.presupuesto.puerta_lateral = 0;
        vm.presupuesto.puerta_central = 0;
        vm.presupuesto.puerta_vidrios = 0;
        vm.presupuesto.puerta_paneles = 0;
        vm.presupuesto.vidrio_5 = 0;
        vm.presupuesto.vidrio_silence_5 = 0;
        vm.presupuesto.vidrio_6 = 0;
        vm.presupuesto.vidrio_silence_6 = 0;
        vm.filtros.precio_flat_id = 56;
        vm.errorperfileria = null;
        vm.errorpuertas = null;
        vm.step = 1;

        vm.getPrecios = function(){
            
            // vm.presupuesto.vidrios_flat = "";
            // vm.presupuesto.divisoria_lateral = "";
            // vm.presupuesto.divisoria_2_vidrios = "";
            // vm.presupuesto.divisoria_2_paneles = "";
            PresupuestoService.Precios(vm).then(function(data){
                  vm.precio = data.precio;
            })
        }

        vm.getSumaPerfileria = function() {

            // Convierte las divisorias a números o a cero
            const lateral = Number(vm.presupuesto.divisoria_lateral) || 0;
            const central = Number(vm.presupuesto.divisoria_central) || 0;
            const vidrios = Number(vm.presupuesto.divisoria_2_vidrios) || 0;
            const paneles = Number(vm.presupuesto.divisoria_2_paneles) || 0;
        
            // Actualiza resultvidrios basándote en los valores actuales
            let sumaDivisorias = lateral + central + vidrios + paneles;
            let resultDivisorias = lateral + central + vidrios * 2;
        
            vm.resultvidrios = resultDivisorias; 
        
            // Verificación y actualización de sinvidrios
            if (vm.resultvidrios === 0 && paneles > 0 && lateral === 0 && central === 0 && vidrios === 0) {
                vm.sinvidrios = 1;
                vm.madera = true;
                vm.getSumaVidrios();
            } else {
                vm.sinvidrios = 0;
                vm.madera = false;
                vm.getSumaVidrios();
            }

            // Esta es la parte que se ejecuta para verificar el error de perfilería
            console.log(vm.filtros.precio_flat_id);
            if  (vm.filtros.precio_flat_id == 56) {
                vm.errorperfileria = sumaDivisorias !== vm.metros_divisiorias; 
            } else if  (vm.filtros.precio_flat_id == 57 ) {
                vm.errorperfileria =  false;
            }

            vm.getCalculosdatosGenerales();
        };
        

        vm.getSumaPuertas = function() {
            vm.getCalculosdatosGenerales();

            let sumaPuertas = 
                (vm.presupuesto.puerta_lateral || 0) + 
                (vm.presupuesto.puerta_central || 0) + 
                (vm.presupuesto.puerta_vidrios || 0) + 
                (vm.presupuesto.puerta_paneles || 0);

            if (sumaPuertas === 0 && vm.presupuesto.num_puertas != 0) {
                vm.errorpuertas = null;  
            } else {
                vm.errorpuertas = sumaPuertas === vm.presupuesto.num_puertas ? false : true;
            }
        };

        vm.getSumaVidrios = function() {
            vm.getCalculosdatosGenerales();
            if (vm.sinvidrios === 1) {
                vm.errorvidrios = false;
                return;
            }

            let sumaVidrios = 
                (vm.presupuesto.vidrio_5 || 0) + 
                (vm.presupuesto.vidrio_silence_5 || 0) + 
                (vm.presupuesto.vidrio_6 || 0) +
                (vm.presupuesto.vidrio_silence_6 || 0);

          
            if (sumaVidrios === 0) {
                vm.errorvidrios = null; 
            } else {
                console.log("suamvirdrios",sumaVidrios);
                console.log("resultvidrios",vm.resultvidrios);
                vm.errorvidrios = sumaVidrios === vm.resultvidrios ? false : true;
            }
        };

        vm.getCalculosdatosGenerales = function() {
               
            if (vm.presupuesto.altura && vm.presupuesto.metros_lineales) {
                vm.metros_divisiorias = parseFloat((vm.presupuesto.metros_lineales * vm.presupuesto.altura).toFixed(2));
            }

            if (vm.presupuesto.altura && vm.presupuesto.num_puertas >= 0 ) {
                vm.metros_puertas = parseFloat((vm.presupuesto.altura * vm.presupuesto.num_puertas).toFixed(2));
                // console.log( "por",vm.presupuesto.altura * vm.presupuesto.num_puertas);
                // console.log( "m2",vm.metros_puertas);
            }

            if (vm.metros_divisiorias && vm.metros_puertas >= 0) {
                vm.metros_totales = parseFloat((vm.metros_divisiorias + vm.metros_puertas).toFixed(2));
            }

            if (vm.metros_totales) {
                vm.instalacion = vm.metros_totales * vm.presupuesto.precio_metro;
            }

        };

        vm.realizarpresupuesto = function(form){
   
            if (vm.loading) {
               return;
            }
            if(form.$valid){
                vm.loading = true;
            }

                PresupuestoService.Presupuestoform(vm).then(function(data){
                    vm.loading = false;
            
                    vm.step = 2;
                    vm.nuevo_presupuesto = data.nuevo_presupuesto;
                    vm.presupuesto_id = vm.nuevo_presupuesto.id;
      
                    vm.getCalculo();
                    vm.scrollTo('mi-container');
                    $timeout(function () {
                        vm.guardarImagen().then(function(imgData) {
                            vm.file_print = imgData;
                            PresupuestoService.SaveImagen(vm);
                        });
                    }, 500);
                  
                })
         
        }

        vm.guardarImagen = function() {
            return html2canvas(document.getElementById('mi-container'), {
                ignoreElements: function(element) {
                    return element.classList.contains('buttons-presupuesto') || element.id === 'buttons-presupuesto';
                }
            }).then(function(canvas) {
                var imgData = canvas.toDataURL('image/png');
                return imgData;
            });
        };


        vm.formatearValores = function() {
            // Formatear los valores de vm.nuevo_presupuesto que incluyen "precio"
            Object.keys(vm.nuevo_presupuesto).forEach(function(key) {
                if (key.includes("precio")) {
                    let rawValue = vm.nuevo_presupuesto[key];
                    let value = Number(rawValue);

                    if (!isNaN(value)) {
                        let formattedValue = new Intl.NumberFormat('es-ES', { 
                            minimumFractionDigits: 2, 
                            maximumFractionDigits: 2, 
                            useGrouping: true 
                        }).format(value);

                        vm.nuevo_presupuesto[key + '_formatted'] = formattedValue;
                    }
                }
            });

            // 🔥 Formatear las variables adicionales que se calculan en getCalculo
            let variablesAFormatear = {
                "instalacion": vm.instalacion,
                "preciototalmateeriales": vm.preciototalmateeriales,
                "instalacionymontajetotal": vm.instalacionymontajetotal,
                "preciototalfixed": vm.preciototalfixed,
                "margencomercialfinal":vm.margencomercialfinal
            };

            Object.keys(variablesAFormatear).forEach(function(varName) {
                let value = Number(variablesAFormatear[varName]); // Convertimos a número

                if (!isNaN(value)) {
                    vm[varName + '_formatted'] = new Intl.NumberFormat('es-ES', { 
                        minimumFractionDigits: 2, 
                        maximumFractionDigits: 2, 
                        useGrouping: true 
                    }).format(value);
                }
            });
        };



         vm.getCalculo = function(form) {

            vm.preciototalmateeriales = 
              (vm.nuevo_presupuesto.precio_divisora_vidrio_lateral) +
              (vm.nuevo_presupuesto.precio_divisora_vidrio_central) +
              (vm.nuevo_presupuesto.precio_divisora_2_vidrios) +
              (vm.nuevo_presupuesto.precio_divisoria_2_paneles) +

              (vm.nuevo_presupuesto.precio_puerta_lateral) +
              (vm.nuevo_presupuesto.precio_puerta_central) +
              (vm.nuevo_presupuesto.precio_puerta_2_vidrios) + 
              (vm.nuevo_presupuesto.precio_puerta_2_paneles) +

              (vm.nuevo_presupuesto.precio_vidrio_5) +
              (vm.nuevo_presupuesto.precio_vidrio_silence_5) +
              (vm.nuevo_presupuesto.precio_vidrio_6) + 
              (vm.nuevo_presupuesto.precio_vidrio_silence_6)
            ;
            
            //Otros calculos
            vm.instalacionymontajetotal = (vm.instalacion) + (vm.preciototalmateeriales);
            vm.margen_comercial = (100 - vm.presupuesto.margen_comercial) / 100;
            vm.margencomercialfinal = (vm.instalacionymontajetotal / vm.margen_comercial) - vm.instalacionymontajetotal;

            //Precio total
            vm.preciototal =   (vm.instalacionymontajetotal) + (vm.margencomercialfinal);
            vm.preciototalfixed = parseFloat(vm.preciototal.toFixed(2));

            //Calculos Transporte
            if (vm.preciototalfixed >= 8000) {
                vm.transportfree = true;
            }else{
                vm.transportfree = false;
                vm.transporte = (vm.preciototalmateeriales * 0.05).toFixed(2);
                vm.transportetotal = (parseFloat(vm.transporte) + parseFloat(vm.precio.arcon)).toFixed(2);
                vm.preciototalfixed = (parseFloat(vm.preciototalfixed) + parseFloat(vm.transportetotal)).toFixed(2);  
            }

            vm.formatearValores();

        };

        vm.validarDivisoriaCentral = function() {
          
            if (vm.filtros.precio_flat_id === 57 && vm.metros_divisiorias) {
                vm.presupuesto.divisoria_central = vm.metros_divisiorias;
                vm.resultvidrios = vm.metros_divisiorias;
                console.log(vm.presupuesto.divisoria_central);
                console.log(vm.metros_divisiorias);
            }
        };

        vm.validacionErrorVidrios = function () {
            return !(
                vm.presupuesto.divisoria_2_paneles &&
                ((vm.presupuesto.divisoria_lateral || 0) +
                 (vm.presupuesto.divisoria_central || 0) +
                 (vm.presupuesto.divisoria_2_vidrios || 0) === 0)
            );
        };

        vm.reset = function(form) {
            form.$setPristine();
            form.$setUntouched(); 
               vm.presupuesto = {
                nombre: "",
                nombre_empresa: "",
                persona_contacto: "",
                email: "",
                direccion: "",
                telefono: "",
                altura: "",
                metros_lineales: "",
                num_puertas: "",
                precio_metro: "",
                margen_comercial: "",
                vidrios_flat: 0,
                divisoria_lateral: "", 
                divisoria_central: "", 
                divisoria_2_vidrios: "", 
                divisoria_2_paneles: "",
                puerta_lateral: "", 
                puerta_central: "", 
                puerta_vidrios: "", 
                puerta_paneles: "",
                vidrio_5: "", 
                vidrio_silence_5: "", 
                vidrio_6: "",
                vidrio_silence_6: "",
                precio_vidrio_5: "",
                precio_vidrio_silence_5: "",
                precio_vidrio_6: "", 
                precio_vidrio_silence_6: "",
                tipo_presupuesto: vm.presupuesto.tipo_presupuesto,
         
            };

            vm.metros_divisiorias = "";
            vm.metros_puertas = "";
            vm.metros_totales = "";
            vm.instalacion = ""; 
        };

        vm.updatePrecio  = function(){
            
            if (vm.presupuesto.vidrios_flat == 0) {
                vm.presupuesto.precio_vidrio_5 = "";
                vm.presupuesto.precio_vidrio_silence_5 = "";
                vm.presupuesto.precio_vidrio_6 = "";
                vm.presupuesto.precio_vidrio_silence_6 = "";
            }

            //Usamos los precios del backend
            if (vm.presupuesto.vidrios_flat == 1) {
                vm.presupuesto.precio_vidrio_5 = vm.precio.precio_vidrio_5;
                vm.presupuesto.precio_vidrio_silence_5 = vm.precio.precio_vidrio_5_silence;
                vm.presupuesto.precio_vidrio_6 = vm.precio.precio_vidrio_6;
                vm.presupuesto.precio_vidrio_silence_6 = vm.precio.precio_vidrio_6_silence;
            }
        }

        vm.resetVidrios = function() {
           
                vm.presupuesto.vidrio_5 = null;
                vm.presupuesto.vidrio_silence_5 = null;
                vm.presupuesto.vidrio_6 = null;
                vm.presupuesto.vidrio_silence_6 = null;
            
                vm.presupuesto.precio_vidrio_5 = "";
                vm.presupuesto.precio_vidrio_silence_5 = "";
                vm.presupuesto.precio_vidrio_6 = "";
                vm.presupuesto.precio_vidrio_silence_6 = "";
           
        };

        vm.resetMontaje = function() {
            vm.presupuesto.precio_metro = "";
        };

        vm.scrollTo = function(id) {
            // Retrasa el scroll un poco para que el DOM se actualice primero
            setTimeout(function() {
                const element = document.getElementById(id);
                if (element) {
                    // console.log("Elemento encontrado:", element);
                    element.scrollIntoView({ behavior: 'smooth' });
                } else {
                    // console.log("Elemento no encontrado");
                }
            }, 500);  // Retraso de 100ms
        };
        
        
    }

})();




// vm.formatearValores = function() {
//             Object.keys(vm.nuevo_presupuesto).forEach(function(key) {
//                 if (key.includes("precio")) {
//                     let rawValue = vm.nuevo_presupuesto[key];

//                     console.log(`🔍 Procesando ${key}:`, rawValue);

//                     let value = Number(rawValue); // Aseguramos que sea número

//                     if (!isNaN(value)) {
//                         // 🔥 Forzamos el formato con separador de miles y dos decimales
//                         let formattedValue = new Intl.NumberFormat('es-ES', { 
//                             minimumFractionDigits: 2, 
//                             maximumFractionDigits: 2,
//                             useGrouping: true //
//                         }).format(value);

//                         vm.nuevo_presupuesto[key + '_formatted'] = formattedValue;

//                         console.log(`✅ ${key}: ${value} -> ${formattedValue}`);
//                     } else {
//                         console.warn(`⚠ No se pudo convertir ${key}:`, rawValue);
//                     }
//                 }
//             });
//         };